<form [formGroup]="_form">
    <div class="form-group">
        <div class="form-row">
            <label class="form-row__label">{{ ".Subject" | lgTranslate }}</label>
            <div class="form-row__controls">{{ _name }}</div>
        </div>
    </div>
    <div class="form-group">
        <div class="form-row form-row--input">
            <label class="form-row__label">{{ ".LocalComment" | lgTranslate }}</label>
            <div class="form-row__controls">
                <textarea class="textarea" formControlName="comment" rows="4"></textarea>
            </div>
        </div>
        <div *ngIf="lastChangeUserName" class="form-row" style="display: block">
            <div>
                {{ ".LastSavedBy" | lgTranslate }} {{ lastChangeUserName }}
                {{ ".On" | lgTranslate }}
                {{ lastChangeDate | date: "dd-MM-yyyy" }}
            </div>
        </div>
    </div>
    <div class="form-group form-group--buttons">
        <div class="form-row">
            <lg-button
                buttonClass="button--primary"
                type="submit"
                [isDisabled]="_isSubmitDisabled || readOnly"
                textLc="FW.SAVE"
                (click)="_onSubmit()"
            >
            </lg-button>
            <lg-button buttonClass="button--secondary" [textLc]="'FW.CANCEL'" (click)="_onClose()">
            </lg-button>
        </div>
    </div>
</form>
